<template>
	<a-layout>
		<!-- 一级导航 -->
		<a-layout-sider collapsible :trigger="null" v-model="collapsed"
			:width="250" class="navi"
			>
			<div id="logo">
				<a-icon style="font-size: 36px;" type="dribbble" />
				<label v-show="!collapsed" style="vertical-align: 8pt;">场地管理</label>
			</div>
			<!-- 左侧导航，动态生成 -->
			<a-menu class='headerMenu'
					mode="inline"
					:selectedKeys=[firstSelectedKeys]
					:openKeys="openKeys"
					:inlineCollapsed="collapsed"
					@click="handleClick"
					@openChange="onOpenChange"
			>
				<template v-for="item in subMenus">
					<a-menu-item  :key="item.meta.key" v-if='!item.children'>
						<router-link :to="item.path">
							<a-icon :type="item.meta.icon" />
							<span>{{ item.meta.title }}</span>
						</router-link>
					</a-menu-item>
					<a-sub-menu :key="item.meta.key" v-else>
						<span slot="title"><a-icon :type="item.meta.icon" /><span>{{ item.meta.title }}</span></span>
						<a-menu-item v-for="subItem in item.children" :key="subItem.meta.key" v-if="!subItem.meta.titleHidden">
							<router-link :to="subItem.path">{{ subItem.meta.title }}</router-link>
						</a-menu-item>
					</a-sub-menu>
				</template>
			</a-menu>
		</a-layout-sider>
		<!-- 主要内容 -->
		<a-layout>
			<!-- 页头 -->
			<a-layout-header>
				<a-icon
		          class="trigger"
		          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
		          @click="() => (collapsed = !collapsed)"
		        />
				<a-breadcrumb>
					<a-breadcrumb-item 
						v-for="(item,index) in breadList" 
						:key="index" 
						v-if="item.name"
					>
						<router-link :to="{path:item.path}">
							{{item.meta.title}}
						</router-link>
					</a-breadcrumb-item>
				</a-breadcrumb>
				<!-- <div class="rightTip">
					<a-tooltip>
						<template slot='title'>
						{{userName}}
						</template>
						<a-avatar icon="user" />
					</a-tooltip>
					<a-avatar shape="square" icon="logout" @click="logout" title="退出系统" />
				</div> -->
				<a-dropdown class="rightTip">
					<span class="ant-dropdown-link">
						<a-avatar icon="user" />
					{{userName}} <a-icon type="down" />
					</span>
					<a-menu slot="overlay">
					<a-menu-item>
						<a href="javascript:;" @click="handlerEditInfo"><a-icon type="edit" />编辑信息</a>
					</a-menu-item>
					<a-menu-item>
						<a href="javascript:;" @click="handlerAlterPwd"><a-icon type="key" />修改密码</a>
					</a-menu-item>
					<a-menu-item>
						<a href="javascript:;" @click="logout"><a-icon type="logout" />退出系统</a>
					</a-menu-item>
					</a-menu>
				</a-dropdown>
			</a-layout-header>
			<!-- 主要内容 -->
			<a-layout-content>
				<router-view></router-view>
			</a-layout-content>
			<!-- 页脚-版权说明 -->
			<a-layout-footer>
				<span class='copyright'>版权所有©上海哇比智能科技有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备2022003207号</a></span>
			</a-layout-footer>
		</a-layout>
		<user-info-modal
			title="用户信息编辑" 
			:visible="modalVisible"
			:record="selRecord"
			@cancel="closeEvent" 
			@ok="editEvent"/>
		<pwd-alter-modal
			title="修改密码" 
			:visible="pwdModalVisible"
			:userId="userId"
			@cancel="closePwdEvent" 
			@ok="editPwdEvent"/>
	</a-layout>
</template>

<script>	
import { GETUSERINFO,LOGOUT } from '@/../static/js/API/apis.js'
import {GETUSERDETAILS} from '@/../static/js/API/systemManageApis.js'
import UserInfoModal from '../../pages/systemManage/components/userInfoModal.vue'
import PwdAlterModal from '../../pages/systemManage/components/pwdAlterModal.vue'
export default{
	name: 'pageFrame',
	components:{UserInfoModal,PwdAlterModal},
	watch: {
		//监听路由变化，设置面包屑
		$route(){
			this.breadList = this.$route.matched
		}
	},
	//方便父子、爷孙页面之间传递参数，省了vuex的麻烦。在子级页面用inject: ['selectedKeys']接收
	provide () {
		return {
			//firstSelectedKeys: this.firstSelectedKeys
		}
	},
	data () {
		return {
			rootSubmenuKeys: ['sub0','sub1','sub2', 'sub3','sub4','sub5', 'sub6','sub7','sub8'],   //一级导航的key
			openKeys: ['sub0'],    //默认展开的一级导航
			firstSelectedKeys: '0',    //默认选中的二级导航，key在路由中设置
			userId: '',
			userName: '',
			collapsed: false,  //左侧导航收起
			subMenus: [],     //一级导航目录
			breadList: this.$route.matched,    //面包屑数组
			modalVisible: false,
			selRecord:{},//用户信息
			pwdModalVisible:false,
		}
	},
	methods: {
		//点击导航
		handleClick (e) {
			this.firstSelectedKeys = e.key
		},
		//打开一个菜单
		onOpenChange (openKeys) {
			const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
			if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
				this.openKeys = openKeys
			} else {
				this.openKeys = latestOpenKey ? [latestOpenKey] : []
			}
		},
	  	//获取用户信息
	  	getUserInfo(){
	  		const self = this;
			GETUSERINFO().then(res => {
				if(res.data){
					self.userId = res.data.userId;
					self.userName = res.data.userRealName; 
				}
			})
	  	},
		handlerEditInfo(){
			let that = this;
			GETUSERDETAILS({id:that.userId}).then(res =>{
				if(res.data){
					that.selRecord = res.data;
					that.modalVisible = true;
				}else{
					that.$message.error("获取用户信息失败！");
				}
			});
		},
		handlerAlterPwd(){
			this.pwdModalVisible = true;
		},
	  	//退出系统
	  	logout() {
			let that = this;
			LOGOUT().then(res=>{
				that.$message.info("退出成功！");
				that.$router.push('/Login');
			})
	  	},
		closeEvent() {
			this.modalVisible = false;
			this.selRecord = {};
		},
		editEvent() {
			this.modalVisible = false;
			this.selRecord = {};
		},
		closePwdEvent() {
			this.pwdModalVisible = false;
		},
		editPwdEvent() {
			this.pwdModalVisible = false;
			this.$message.info("密码重置成功，请重新登录！");
			this.logout();
		},
	},
	created () {
		//动态放入一级导航
		this.subMenus = this.$router.options.routes[2]['children']
		this.firstSelectedKeys = this.$route.meta.key?this.$route.meta.key:this.firstSelectedKeys
	},
	updated () {
  		this.firstSelectedKeys = this.$route.meta.key?this.$route.meta.key:this.firstSelectedKeys
	},
	mounted(){
		this.getUserInfo();
		this.openKeys = [this.$route.meta.subKey?this.$route.meta.subKey:'sub0']
	}
}
</script>

<style scoped src="@/../static/css/home.css">
.navi{
	height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/common/layout/pageFrame.vue